import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'environments/environment';
import { FuseAlertType } from '@fuse/components/alert';
import { ChangeDetectorRef } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Router } from '@angular/router';

@Component({
    selector: 'app-mfa-reset-request',
    templateUrl: './mfa-reset-request.component.html',
    styleUrls: ['./mfa-reset-request.component.css'],
    standalone: false
})
export class MfaResetRequestComponent implements OnInit {
  private key = '';
  signedIn: boolean;
  private requestId = '';
  username = '';
  alert: { type: FuseAlertType; message: string } = null;
  showAlert: boolean = false;
  actionCompleted: boolean = false;
  isSubmitting: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private _changeDetectorRef: ChangeDetectorRef,
    private _translocoService: TranslocoService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.key = this.route.snapshot.queryParamMap.get('key')?.trim() || '';
    const qp = this.route.snapshot.queryParamMap;
    this.requestId = qp.get('key')?.trim() || '';
    this.username = qp.get('username') || '';
    if (!this.key) {
      console.error('[MFA] Missing key in URL');
    }
  }

  onConfirmReset(): void {
    this.isSubmitting = true;
    if (!this.requestId) { console.warn('[MFA] Missing requestId'); return; }

    const query = `
    mutation Mutation($requestId: String) {
      consumeMfaResetRequest(requestId: $requestId) {
        message
        status
      }
    }
  `;
    const variables = { requestId: this.requestId };

    this.http.post(environment.config.endpoints.pub.url, { query, variables }, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    })
      .subscribe({
        next: (res: any) => {
          const data = res?.data?.consumeMfaResetRequest;

          if (!data) {

            const errorMessage = res?.errors?.[0]?.message?.toLowerCase?.() ?? '';
            console.log('[MFA] Checking request result for user:', this.username);
            if (errorMessage.includes('mfa reset request') && errorMessage.includes('expired')) {
              this.setAlert('error', this._translocoService.translate(
                `MFA reset request has expired. Please request a new reset email.`
              ));
            } else if (errorMessage.includes('failed to find mfa reset request')) {
              this.setAlert('error', this._translocoService.translate(
                'This request is no longer valid. Please sign in and request a new MFA reset email.'
              ));
            } else {
              this.setAlert('error', this._translocoService.translate(
                'Unexpected error. Please try again later.'
              ));
            }
            setTimeout(() => {
              this.router.navigate(['/sign-in']);
            }, 5000);
            this.isSubmitting = false;
            this.actionCompleted = true;
            this._changeDetectorRef.markForCheck();
            return;
          }

          const isSuccessful = String(data.status).toLowerCase() === 'success';

          if (isSuccessful) {
            this.setAlert('success', this._translocoService.translate(data.message || 'MFA has been successfully disabled.'));
            this.actionCompleted = true;
          } else {
            const messageText = data.message?.toLowerCase?.() ?? '';

            if (messageText.includes('expired')) {
              this.setAlert('error', this._translocoService.translate('This request has expired. Please request a new MFA reset email.'));
            } else {
              this.setAlert('error', this._translocoService.translate(data.message || 'Failed to reset MFA.'));
            }
          }
          setTimeout(() => {
            this.router.navigate(['/sign-in']);
          }, 5000);
        },
        error: (err) => console.error('[MFA] HTTP error:', err),
      });
  }

  private setAlert(type: FuseAlertType, message: string): void {
    this.alert = { type, message };
    this.showAlert = true;
    this._changeDetectorRef.markForCheck();
    setTimeout(() => {
      this.showAlert = false;
      this._changeDetectorRef.markForCheck();
    }, 5000);
  }

}
